import React from 'react';
import Box from '@mui/material/Box';
import AppMenuItem, { AppMenuItemBoxProps } from './app-menu-item';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';

interface SortableItemProps extends AppMenuItemBoxProps {
  id: number;
}

const AppMenuItemSortable = ({ id, ...props }: SortableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Box sx={style} ref={setNodeRef} {...attributes}>
      <AppMenuItem isActive={isDragging} listeners={listeners} {...props} />
    </Box>
  );
};

export default AppMenuItemSortable;
